// extracted by mini-css-extract-plugin
export default {"AddCommentContainer":"AddComment_AddCommentContainer__2YHXs","Logo":"AddComment_Logo__zIaTp","Input":"AddComment_Input__ePqeq","PostButton":"AddComment_PostButton__CMuXh"};